// import React from "react";
// import "./perfect_match.css";
// // Import your images (update these paths with your actual image files)
// import onboardingImage from "../../img/des_sec/discover_features_1.svg";
// import ukgPro from "../../img/des_sec/UKG PRO WFM Implementation.svg";
// import advance from "../../img/des_sec/Advanced Reporting & Business Analytics.svg";
// import Consulting from "../../img/des_sec/Consulting & Assessment.svg";
// import compliance from "../../img/des_sec/Compliance & Reporting.svg";
// import Ongoing from "../../img/des_sec/Ongoing Support & Optimisation.svg";
// import dashboardImage from "../../img/des_sec/discover_features_6.svg";
// import complianceImage from "../../img/des_sec/discover_features_1.svg";
// import documentImage from "../../img/des_sec/discover_features_6.svg";
// import dividerImage from "../../img/des_sec/perfect_match_bg.svg" ;

// const PerfectMatch = () => {
//   return (
//     <div className="perfectMatch-container-pm">
//       {/* Background image would be set in CSS */}

//       <div className="perfectMatch-content-pm">
//         {/* Left Column */}
//         <div className="perfectMatch-column-pm left-column-pm">
//           <div className="perfectMatch-item-pm image-item-pm">
//             <img
//               src={ukgPro}
//               alt="Onboarding illustration"
//               className="feature-image-pm"
//             />
//           </div>
//           <div className="perfectMatch-item-pm text-item-pm pt-5 pb-4">
//             <h2>Advanced Reporting & Business Analytics</h2>
//             <p>
//             Real-time dashboards and custom reports for workforce insights and compliance, improving decision-making accuracy by 25%.
//             </p>
//           </div>
//           <div className="perfectMatch-item-pm image-item-pm">
//             <img
//               src={Consulting}
//               alt="Compliance illustration"
//               className="feature-image-pm"
//             />
//           </div>
//           <div className="perfectMatch-item-pm text-item-pm pt-5 pb-4">
//             <h2>Compliance & Reporting</h2>
//             <p>
//             Full support for critical compliance reports such as CLRA, Bill Verification, and industry-specific regulations globally. 
//             </p>
//           </div>
//           <div className="perfectMatch-item-pm image-item-pm">
//             <img
//               src={Ongoing}
//               alt="Compliance illustration"
//               className="feature-image-pm"
//             />
//           </div>
          
          
          
//         </div>

//         {/* Middle Divider */}
//         <div className="perfectMatch-divider-pm">
//           <img src={dividerImage} alt="Divider" className="divider-image-pm" />
//         </div>

//         {/* Right Column */}
//         <div className="perfectMatch-column-pm right-column-pm">
//           <div className="perfectMatch-item-pm text-item-pm">
//           <h2>UKG PRO WFM Implementation Migration</h2>
//             <p>
//             End-to-end deployment of Time & Attendance, Payroll, Advanced Scheduling, and Leave Management solutions, with a track record of reducing payroll errors by 20%.
//             </p>
            
//           </div>
//           <div className="perfectMatch-item-pm image-item-pm">
//             <img
//               src={advance}
//               alt="Dashboard illustration"
//               className="feature-image-pm"
//             />
//           </div>
//           <div className="perfectMatch-item-pm text-item-pm pt-5 pb-4">
//           <h2>Consulting & Assessment</h2>
//             <p>
//               In-depth evaluation of your existing HR & workforce systems to
//               design the optimal UKG solution, ensuring alignment with business
//               goals.
//             </p>
//           </div>

//           <div className="perfectMatch-item-pm image-item-pm">
//             <img
//               src={compliance}
//               alt="Document management illustration"
//               className="feature-image-pm"
//             />
//           </div>
         

         
//           <div className="perfectMatch-item-pm text-item-pm pt-5 pb-4">
//           <h2>Ongoing Support & Optimisation</h2>
//             <p>
//               Post-go-live support for UKG Workforce Central, PRO WFM, and
//               custom modules, ensuring up to 99% uptime and smooth operations
//               with regular enhancements.
//             </p>
           
//           </div>

          
//         </div>
//       </div>

//       {/* Main heading */}
//       <h1 className="main-heading-pm">Why we're your Perfect Match</h1>
//     </div>
//   );
// };

// export default PerfectMatch;

import React, { useRef, useEffect, useState } from "react";
import { useSpring, animated } from '@react-spring/web';
import "./perfect_match.css";
import onboardingImage from "../../img/des_sec/discover_features_1.svg";
import ukgPro from "../../img/des_sec/UKG PRO WFM Implementation.svg";
import advance from "../../img/des_sec/Advanced Reporting & Business Analytics.svg";
import Consulting from "../../img/des_sec/Consulting & Assessment.svg";
import compliance from "../../img/des_sec/Compliance & Reporting.svg";
import Ongoing from "../../img/des_sec/Ongoing Support & Optimisation.svg";
import dividerImage from "../../img/des_sec/perfect_match_bg.svg";

const PerfectMatch = () => {
  // State for container visibility
  const [containerInView, setContainerInView] = useState(false);
  const containerRef = useRef(null);

  // State for heading
  const [headingInView, setHeadingInView] = useState(false);
  const headingRef = useRef(null);

  // State for left column items (3 items)
  const leftRef1 = useRef(null);
  const leftRef2 = useRef(null);
  const leftRef3 = useRef(null);
  const leftRef4 = useRef(null);
  const leftRef5 = useRef(null);
  const [leftInView, setLeftInView] = useState([false, false, false, false, false]);

  // State for right column items (5 items)
  const rightRef1 = useRef(null);
  const rightRef2 = useRef(null);
  const rightRef3 = useRef(null);
  const rightRef4 = useRef(null);
  const rightRef5 = useRef(null);
  const [rightInView, setRightInView] = useState([false, false, false, false, false]);

  // State for divider
  const [dividerInView, setDividerInView] = useState(false);
  const dividerRef = useRef(null);
  const [hasDividerAnimated, setHasDividerAnimated] = useState(false);

  // Intersection Observer for container
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setContainerInView(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  // Intersection Observer for heading
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setHeadingInView(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (headingRef.current) observer.observe(headingRef.current);
    return () => {
      if (headingRef.current) observer.unobserve(headingRef.current);
    };
  }, []);

  // Intersection Observers for left column items
  useEffect(() => {
    const leftRefs = [leftRef1, leftRef2, leftRef3, leftRef4, leftRef5];
    const observers = leftRefs.map((ref, index) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setLeftInView(prev => {
            const newState = [...prev];
            newState[index] = entry.isIntersecting;
            return newState;
          });
        },
        { threshold: 0.3 }
      );

      if (ref.current) observer.observe(ref.current);
      return observer;
    });

    return () => {
      leftRefs.forEach((ref, index) => {
        if (ref.current) observers[index].unobserve(ref.current);
      });
    };
  }, []);

  // Intersection Observers for right column items
  useEffect(() => {
    const rightRefs = [rightRef1, rightRef2, rightRef3, rightRef4, rightRef5];
    const observers = rightRefs.map((ref, index) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setRightInView(prev => {
            const newState = [...prev];
            newState[index] = entry.isIntersecting;
            return newState;
          });
        },
        { threshold: 0.3 }
      );

      if (ref.current) observer.observe(ref.current);
      return observer;
    });

    return () => {
      rightRefs.forEach((ref, index) => {
        if (ref.current) observers[index].unobserve(ref.current);
      });
    };
  }, []);

  // Intersection Observer for divider (one-time animation)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasDividerAnimated) {
          setDividerInView(true);
          setHasDividerAnimated(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (dividerRef.current) observer.observe(dividerRef.current);
    return () => {
      if (dividerRef.current) observer.unobserve(dividerRef.current);
    };
  }, [hasDividerAnimated]);

  // Animation for the main heading
  const headingAnimation = useSpring({
    opacity: headingInView ? 1 : 0,
    transform: headingInView ? 'translateY(0px)' : 'translateY(30px)',
    config: { tension: 180, friction: 35, mass: 1 }
  });

  // Animations for left column items
  const leftAnimation1 = useSpring({
    opacity: leftInView[0] ? 1 : 0,
    transform: leftInView[0] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation2 = useSpring({
    opacity: leftInView[1] ? 1 : 0,
    transform: leftInView[1] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation3 = useSpring({
    opacity: leftInView[2] ? 1 : 0,
    transform: leftInView[2] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation4 = useSpring({
    opacity: leftInView[3] ? 1 : 0,
    transform: leftInView[3] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const leftAnimation5 = useSpring({
    opacity: leftInView[4] ? 1 : 0,
    transform: leftInView[4] ? 'translateX(0px)' : 'translateX(-50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });

  // Animations for right column items
  const rightAnimation1 = useSpring({
    opacity: rightInView[0] ? 1 : 0,
    transform: rightInView[0] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation2 = useSpring({
    opacity: rightInView[1] ? 1 : 0,
    transform: rightInView[1] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation3 = useSpring({
    opacity: rightInView[2] ? 1 : 0,
    transform: rightInView[2] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation4 = useSpring({
    opacity: rightInView[3] ? 1 : 0,
    transform: rightInView[3] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });
  const rightAnimation5 = useSpring({
    opacity: rightInView[4] ? 1 : 0,
    transform: rightInView[4] ? 'translateX(0px)' : 'translateX(50px)',
    config: { tension: 160, friction: 30, mass: 1 }
  });

  // Animation for divider
  const dividerAnimation = useSpring({
    opacity: dividerInView ? 1 : 0,
    transform: dividerInView ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 140, friction: 35, mass: 1 }
  });

  return (
    <div className={`perfectMatch-container-pm ${containerInView ? 'animate-background' : ''}`} ref={containerRef}>
      <div className="perfectMatch-content-pm">
        {/* Left Column */}
        <div className="perfectMatch-column-pm left-column-pm">
          <animated.div className="perfectMatch-item-pm image-item-pm" style={leftAnimation1} ref={leftRef1}>
            <img src={ukgPro} alt="UKG PRO WFM Implementation" className="feature-image-pm" />
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm text-item-pm pt-5 pb-4" style={leftAnimation2} ref={leftRef2}>
            <h2>Advanced Reporting & Business Analytics</h2>
            <p>Real-time dashboards and custom reports for workforce insights and compliance, improving decision-making accuracy by 25%.</p>
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm image-item-pm" style={leftAnimation3} ref={leftRef3}>
            <img src={Consulting} alt="Consulting & Assessment" className="feature-image-pm" />
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm text-item-pm pt-5 pb-4" style={leftAnimation4} ref={leftRef4}>
            <h2>Compliance & Reporting</h2>
            <p>Full support for critical compliance reports such as CLRA, Bill Verification, and industry-specific regulations globally.</p>
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm image-item-pm" style={leftAnimation5} ref={leftRef5}>
            <img src={Ongoing} alt="Ongoing Support & Optimisation" className="feature-image-pm" />
          </animated.div>
        </div>

        {/* Middle Divider */}
        {/* <animated.div className="perfectMatch-divider-pm" style={dividerAnimation} ref={dividerRef}> */}
        <div className="perfectMatch-divider-pm">
          <img src={dividerImage} alt="Divider" className="divider-image-pm" />
          </div>
        {/* </animated.div> */}

        {/* Right Column */}
        <div className="perfectMatch-column-pm right-column-pm">
          <animated.div className="perfectMatch-item-pm text-item-pm" style={rightAnimation1} ref={rightRef1}>
            <h2>UKG PRO WFM Implementation Migration</h2>
            <p>End-to-end deployment of Time & Attendance, Payroll, Advanced Scheduling, and Leave Management solutions, with a track record of reducing payroll errors by 20%.</p>
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm image-item-pm" style={rightAnimation2} ref={rightRef2}>
            <img src={advance} alt="Advanced Reporting" className="feature-image-pm" />
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm text-item-pm pt-5 pb-4" style={rightAnimation3} ref={rightRef3}>
            <h2>Consulting & Assessment</h2>
            <p>In-depth evaluation of your existing HR & workforce systems to design the optimal UKG solution, ensuring alignment with business goals.</p>
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm image-item-pm" style={rightAnimation4} ref={rightRef4}>
            <img src={compliance} alt="Compliance & Reporting" className="feature-image-pm" />
          </animated.div>
          
          <animated.div className="perfectMatch-item-pm text-item-pm pt-5 pb-4" style={rightAnimation5} ref={rightRef5}>
            <h2>Ongoing Support & Optimisation</h2>
            <p>Post-go-live support for UKG Workforce Central, PRO WFM, and custom modules, ensuring up to 99% uptime and smooth operations with regular enhancements.</p>
          </animated.div>
        </div>
      </div>

      {/* Main heading */}
      <animated.h1 className="main-heading-pm" style={headingAnimation} ref={headingRef}>
        Why we're your Perfect Match
      </animated.h1>
    </div>
  );
};

export default PerfectMatch;
